import React from "react"
import { AutoComplete } from "components/AutoComplete"
import { DateRangePicker } from "components/DatePicker"
import { useProductionScheduleContext } from "./ProductionScheduleContext"

import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"

import { isEmpty } from "utils/commonUtils"
import { parseDate } from "utils/dateFormatUtils"
import { Button } from "components/Button"
import emptyIcon from "../../assets/images/schedule/production-warning.svg"

const EMPTY_TIMELINE_SIZE = 0

const ProductionScheduleHeader = ({
    range,
    tempRange,
    productionFilter,
    productionListing,
    onDateChange,
    onSetProduction,
    onSearch,
    isDatePickerDisabled,
    isLoading,
    productionDetailsData,
    onShowNextInventory,
}) => {
    const { loading, timeLineHashMap } = useProductionScheduleContext()
    return (
        <div className="mb-3">
            <div className="d-flex align-items-center justify-content-between admin-inventory-request-form-fields">
                <div className="w-100  align-items-center admin-inventory-request-autocomplete production-line-header">
                    <div className="d-flex justify-content-start w-100 align-items-center">
                        <div className="mx-2 d-flex production-line-param">
                            <DateRangePicker
                                range={
                                    !!range[0]?.startDate ? range : tempRange
                                }
                                onChange={onDateChange}
                                disabled={
                                    isDatePickerDisabled ||
                                    isLoading ||
                                    loading ||
                                    isEmpty(productionDetailsData?.stages)
                                }
                                isLoading={isLoading || loading}
                                minDate={parseDate(
                                    productionDetailsData?.startDate
                                )}
                                maxDate={
                                    productionDetailsData?.endDate
                                        ? parseDate(
                                              productionDetailsData?.endDate
                                          )
                                        : undefined
                                }
                                hasUserSelectedDate={true}
                            />
                        </div>
                        <div className="min-250-w margin-right-handle me-2 production-line-param">
                            <AutoComplete
                                placeholder="Select Production Line"
                                value={productionFilter}
                                // customStyles={customStyles.AdminAppSelectStyles}
                                customStyles={autoCompleteStyles.STYLE_SIX}
                                onInputChange={val => onSearch(val)}
                                options={productionListing.data}
                                onChange={val => onSetProduction(val)}
                                closeMenuOnSelect={true}
                                isLoading={productionListing?.fetching}
                                classNamePrefix="status-header-search-admin"
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center  production-line-header-buttons">
                        {timeLineHashMap?.size > EMPTY_TIMELINE_SIZE && (
                            <Button
                                title={
                                    <div className="d-flex gap-2 align-items-center">
                                        <img
                                            alt="slot-card-icon"
                                            src={emptyIcon}
                                            width={15}
                                            height={15}
                                        />
                                        <p>Show Next Inventory Warning</p>
                                    </div>
                                }
                                className={"production-button bg-white"}
                                onClick={onShowNextInventory}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductionScheduleHeader
